// extracted by mini-css-extract-plugin
export var skipAnimation = "_3z-0";